import { ComponentType } from 'react';
import * as AiIcons from 'react-icons/ai';
import * as BiIcons from 'react-icons/bi';
import * as BsIcons from 'react-icons/bs';
import * as FaIcons from 'react-icons/fa';
import * as GiIcons from 'react-icons/gi';
import * as HiIcons from 'react-icons/hi';
import * as IoIcons from 'react-icons/io5';
import * as MdIcons from 'react-icons/md';
import * as PiIcons from 'react-icons/pi';
import * as RiIcons from 'react-icons/ri';
import * as SiIcons from 'react-icons/si';
import * as SlIcons from 'react-icons/sl';
import * as TbIcons from 'react-icons/tb';
import { FaChildren } from 'react-icons/fa6';

const Fa6Icons = {
  FaChildren
};

// Cache for loaded icons
const iconCache = new Map<string, ComponentType>();

const ICON_LIBRARIES = {
  ai: AiIcons,
  bi: BiIcons,
  bs: BsIcons,
  fa: {
    ...FaIcons,
    ...Fa6Icons
  }, // Combine both Fa and Fa6 libraries
  gi: GiIcons,
  hi: HiIcons,
  io5: IoIcons,
  md: MdIcons,
  pi: PiIcons,
  ri: RiIcons,
  si: SiIcons,
  sl: SlIcons,
  tb: TbIcons
} as const;

// Finds the library key based on icon prefix
const getIconLibrary = (
  iconName: string
): keyof typeof ICON_LIBRARIES | null => {
  const prefixRegex = /^([A-Z][a-z]?)/;
  const prefixMatch = prefixRegex.exec(iconName);
  if (!prefixMatch) return null;

  const prefix = prefixMatch[1];

  // Convert prefix to lowercase library key, with special case for Io -> io5
  if (prefix === 'Io') return 'io5';

  const libraryKey = prefix.toLowerCase() as keyof typeof ICON_LIBRARIES;
  return ICON_LIBRARIES[libraryKey] ? libraryKey : null;
};

// Load icon with caching
export const loadIcon = (iconName: string): ComponentType | null => {
  // Verify cache first
  if (iconCache.has(iconName)) {
    return iconCache.get(iconName)!;
  }

  // Detect library automatically
  const library = getIconLibrary(iconName);
  if (!library) {
    console.warn(`No se pudo detectar la librería para el icono: ${iconName}`);
    return null;
  }

  try {
    const iconLibrary = ICON_LIBRARIES[library];
    const IconComponent = (iconLibrary as Record<string, ComponentType>)[
      iconName
    ];

    if (!IconComponent) {
      console.warn(`Icono ${iconName} no encontrado en react-icons/${library}`);
      return null;
    }

    // Save on cache
    iconCache.set(iconName, IconComponent);
    return IconComponent;
  } catch (error) {
    console.error(`Error cargando icono ${iconName}:`, error);
    return null;
  }
};

export const ICON_SIZES = {
  XS: 14,
  S: 16,
  MD: 24,
  LG: 32,
  XL: 50
} as const;
